import cleanFieldLabel from './cleanFieldLabel';
import getFieldLabel from './getFieldLabel';

/**
 * Returns a map of form field text to it's related error.
 *
 * @param $elements array of failed validation elements. Element are those that fail HTML5 validation.
 * @returns map of form field text and related errors.
 */
const getInvalidFieldsHTML5 = ($elements) => {
	const invalidFields = {};

	$elements.each((_index, element) => {
		const text = cleanFieldLabel(getFieldLabel(element));

		if (element.validationMessage) {
			invalidFields[text] = element.validationMessage;
		}
	});

	return invalidFields;
};

export default getInvalidFieldsHTML5;
